
import React, {Component} from 'react'
import { connect } from 'react-redux'
import GenericDockButton from './GenericDockButton'

const navigationButtonsIds = require('../navigationButtonsIds');
const translator = require('../../../utils/translator/translator.js');
const userNotificationsUtil = require('../../../utils/userNotifications/userNotificationsUtil');

class NotificationButton extends Component 
{
    render()
    {
        let numberComponent = null;
        let unReadNotificationsCount = userNotificationsUtil.getUnReadNotifications().length;
        if (unReadNotificationsCount > 0)
        {
            numberComponent = <div style={{position:'absolute', top:'0px', right:'1px', 
                                            background:'var(--colors-primary)', color:'white',
                                            borderRadius:10, border:'1px solid black',
                                            textAlign:'center', 
                                            paddingLeft:'10px', paddingRight:'10px'}}
                                    onClick={(event) =>
                                    {
                                        event.stopPropagation();
                                        this.props.onClick();
                                    }}>
                                    {unReadNotificationsCount}
                                </div>
        }
        return <div style={{position:'relative'}}>
                    <GenericDockButton  button={this.props.button} 
                                        onClick={this.props.onClick} 
                                        marginLeft={this.props.marginLeft}
                                        marginRight={this.props.marginRight}
                                        caption={translator.getLabel(this.props.button)}/>

                    {numberComponent}
                </div>
    }
}

const mapStateToProps = state => 
{
    return { 
                userNotificationLastAddedDateTime: state.userNotificationLastAddedDateTime,
           }
}

export default connect(mapStateToProps)(NotificationButton)